
import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-icon',
    template: `@if (props.icon) {
  <mat-icon>{{field.formControl?.value}}</mat-icon>
}
<span>{{props.label}}</span>
@if (!props.description) {
  <mat-hint>{{props.description}}</mat-hint>
}`,
    styleUrls: ['../../../assets/global-settings.scss'],
    standalone: false
})
export class IconComponent extends FieldType {
}
